import { LegalPage } from "./LegalPage";

export function RefundPage() {
  return (
    <LegalPage
      eyebrow="Legal"
      lastUpdated="May 2025"
      title="REFUND POLICY"
    >
      <p>
        This Refund Policy applies to gaming session bookings made through the Gaamed platform.
        Please read this policy carefully before confirming a booking.
      </p>
      <p>
        Because Gaamed is a technology intermediary and does not process payments directly,
        refunds are coordinated between you and the venue operator with Gaamed's facilitation
        where necessary. Venue operators agree to this policy as a condition of listing on
        the platform.
      </p>

      <h2>1. Player-Initiated Cancellations</h2>
      <h3>Cancellation within the venue's window</h3>
      <p>
        Each venue sets its own cancellation window (the minimum number of hours before a
        session at which cancellation is permitted without penalty). This window is displayed
        on the venue's profile and during checkout before you confirm a booking.
      </p>
      <ul>
        <li>
          If you cancel your booking before the cancellation window expires, you are entitled
          to a <strong>full refund</strong> of any amount paid.
        </li>
        <li>
          Refunds are processed back to your original payment method. Processing time depends
          on your payment provider — typically 3–7 business days.
        </li>
      </ul>
      <h3>Cancellation outside the venue's window (late cancellation)</h3>
      <ul>
        <li>
          If you cancel after the cancellation window has closed, the venue's no-show penalty
          may apply. The penalty amount is set by the venue operator and is displayed on the
          venue profile.
        </li>
        <li>
          Any amount paid beyond the no-show penalty is refunded to you.
        </li>
        <li>
          If no penalty has been set by the venue, a <strong>full refund</strong> applies
          regardless of when you cancel.
        </li>
      </ul>

      <h2>2. No-Shows</h2>
      <p>
        A no-show occurs when you have a confirmed booking and do not arrive within a
        reasonable time after the session start time (as determined by venue staff).
      </p>
      <ul>
        <li>
          If the venue has a no-show penalty configured, that penalty will be applied and the
          remainder refunded.
        </li>
        <li>
          If no penalty has been configured, no charge applies — though repeated no-shows may
          affect your ability to book at that venue in the future.
        </li>
      </ul>

      <h2>3. Provider-Initiated Cancellations</h2>
      <p>
        If a venue operator cancels your confirmed booking for any reason, you are entitled to
        a <strong>full refund</strong> with no penalties or fees applied. Gaamed will
        facilitate the refund process on your behalf.
      </p>
      <p>
        Repeated provider-initiated cancellations without valid cause may result in the
        venue's listing being suspended from the platform.
      </p>

      <h2>4. Technical Issues</h2>
      <p>
        If you experience a technical issue caused by the Gaamed platform (for example, an
        error in the booking system, an invalid QR code or a platform outage) that prevents
        you from checking in for a booking you paid for, you are entitled to a{" "}
        <strong>full refund</strong> regardless of the venue's cancellation policy.
      </p>
      <p>
        To claim a technical-issue refund, contact us at{" "}
        <a href="mailto:support@gaamed.com">support@gaamed.com</a> within 48 hours of the
        affected session start time with a description of the issue.
      </p>

      <h2>5. Sessions Paid Directly to Venues</h2>
      <p>
        Gaamed does not currently collect payments on behalf of venues. If you paid for a
        session directly to the venue (in cash or by card at the venue), refunds for
        cancellations are subject to the venue's direct refund terms. Gaamed cannot process
        refunds for payments not made through the platform.
      </p>
      <p>
        In the event of a dispute with a venue operator, contact us at{" "}
        <a href="mailto:support@gaamed.com">support@gaamed.com</a> and we will do our best to
        mediate.
      </p>

      <h2>6. How to Request a Refund</h2>
      <ol>
        <li>Cancel your booking through the Gaamed app or web portal (if within the cancellation window).</li>
        <li>
          For cancellations outside the window, late-cancellation refund requests, or
          technical-issue refunds, email{" "}
          <a href="mailto:support@gaamed.com">support@gaamed.com</a> with your booking
          reference and a description of your situation.
        </li>
        <li>We will review your request and respond within 3 business days.</li>
      </ol>

      <h2>7. Changes to This Policy</h2>
      <p>
        We reserve the right to update this Refund Policy at any time. Changes will be posted
        on this page with an updated date. The policy in effect at the time of your booking
        will apply to that booking.
      </p>

      <h2>8. Contact</h2>
      <p>
        Questions about refunds? Contact us at:{" "}
        <a href="mailto:support@gaamed.com">support@gaamed.com</a>
      </p>
    </LegalPage>
  );
}
